import { uuidv4 } from "common";
import { useTable } from "../TableContext";
import { useSuperTitle } from "./SuperTitle";
import { ParentProps, Show, createMemo } from "solid-js";
import style from '../st-table.module.css'

export interface HeadCellProps extends ParentProps {
    id?: string
}

export const HeadCell = (props: HeadCellProps) => {
    const table = useTable();
    const superTitle = useSuperTitle();
    const id = props.id ?? uuidv4()

    const idx = createMemo(() => table.visibleColumnIds().indexOf(id));

    const depth = superTitle ? superTitle.depth + 1 : 0;

    table.registerColumn(id, depth);
    superTitle?.registerColumn(id);

    const s = createMemo(() => {
        return `grid-column-start: ${idx() + 1}; grid-column-end: ${idx() + 2}; grid-row-start: ${depth + 1}; grid-row-end: -1;`
    })

    const isVisible = createMemo(() => {
        return !table.hiddenColumnIds().includes(id);
    })

    return (
        <Show when={isVisible()}>
            <th class={style['st-table-head-cell']} style={s()}>
                {props.children}
                <div class={style['st-table-head-cell-actions']}>
                    <span class={`${style['st-head-action']} fa fa-caret-down`}></span>
                    <div class='flexbox vertical'>
                        <span class={`${style['st-head-action']} fa fa-caret-up`}></span>
                        <span class={`${style['st-head-action']} fa fa-caret-down`}></span>
                    </div>
                    <span class={`${style['st-head-action']} fa fa-filter`}></span>
                </div>
            </th>
        </Show>
    )
}